export const WORKSPACE_ACTIVITY_CONTENT_ID = 'workspace-activity-content';
export const WORKSPACE_UPLOADS_ACTIVITY_CONTENT_ID = 'workspace-uploads-activity-content';
